import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../../../../screens/communities/components/GroupMembersList/__generated__/user.fragment.generated';
import { MediaFileFragmentDoc } from '../../../../fragments/__generated__/file.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateNewPostMutationVariables = Types.Exact<{
  content: Types.Scalars['String']['input'];
  media?: Types.InputMaybe<Array<Types.Scalars['Upload']['input']> | Types.Scalars['Upload']['input']>;
  status: Types.Scalars['String']['input'];
  selectedUsers?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  organisationTeamsIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  informationFeedId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  communityGroupUuid?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  organisationUuid?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  publishAt?: Types.InputMaybe<Types.Scalars['Timestamp']['input']>;
}>;


export type CreateNewPostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Post', id: string, uuid: string, createdAt: number, updatedAt: number, publishedAt?: number | null, pinned: boolean, status: string, type: Types.PostType, informationFeedId?: string | null, communityGroupId?: string | null, content?: string | null, media?: string | null, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string }>, likes?: Array<{ __typename?: 'PostLike', id: string }> | null, selectedUsers?: Array<{ __typename?: 'PostAccess', id: string, post: { __typename?: 'Post', id: string }, user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }> } };


export const CreateNewPostDocument = gql`
    mutation CreateNewPost($content: String!, $media: [Upload!], $status: String!, $selectedUsers: [String!], $organisationTeamsIds: [ID!], $informationFeedId: ID, $communityGroupUuid: ID, $organisationUuid: ID, $publishAt: Timestamp) {
  createPost(
    data: {content: $content, mediaFiles: $media, status: $status, selectedUsers: $selectedUsers, informationFeedId: $informationFeedId, communityGroupUuid: $communityGroupUuid, organisationTeamsIds: $organisationTeamsIds, organisationUuid: $organisationUuid, publishAt: $publishAt}
  ) {
    id
    uuid
    createdAt
    updatedAt
    publishedAt
    pinned
    status
    type
    author {
      ...UserBasicInfo
    }
    informationFeedId
    communityGroupId
    comments {
      id
    }
    likes {
      id
    }
    selectedUsers {
      id
      post {
        id
      }
      user {
        ...UserBasicInfo
      }
    }
    content
    media
    mediaFiles {
      ...MediaFile
    }
  }
}
    ${UserBasicInfoFragmentDoc}
${MediaFileFragmentDoc}`;
export type CreateNewPostMutationFn = Apollo.MutationFunction<CreateNewPostMutation, CreateNewPostMutationVariables>;

/**
 * __useCreateNewPostMutation__
 *
 * To run a mutation, you first call `useCreateNewPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewPostMutation, { data, loading, error }] = useCreateNewPostMutation({
 *   variables: {
 *      content: // value for 'content'
 *      media: // value for 'media'
 *      status: // value for 'status'
 *      selectedUsers: // value for 'selectedUsers'
 *      organisationTeamsIds: // value for 'organisationTeamsIds'
 *      informationFeedId: // value for 'informationFeedId'
 *      communityGroupUuid: // value for 'communityGroupUuid'
 *      organisationUuid: // value for 'organisationUuid'
 *      publishAt: // value for 'publishAt'
 *   },
 * });
 */
export function useCreateNewPostMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewPostMutation, CreateNewPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewPostMutation, CreateNewPostMutationVariables>(CreateNewPostDocument, options);
      }
export type CreateNewPostMutationHookResult = ReturnType<typeof useCreateNewPostMutation>;
export type CreateNewPostMutationResult = Apollo.MutationResult<CreateNewPostMutation>;
export type CreateNewPostMutationOptions = Apollo.BaseMutationOptions<CreateNewPostMutation, CreateNewPostMutationVariables>;